module.exports = __webpack_public_path__ + "static/media/ig-icon--light-blue.e0a13f14.svg";